import { useEffect, useState } from "react";
import { api } from "../api/client";

interface LinkedAccount {
  id: string;
  provider: string;
  external_account_id: string;
  scope: string;
  status: string;
  created_at: number;
}

export function Providers() {
  const [accounts, setAccounts] = useState<LinkedAccount[]>([]);
  const [provider, setProvider] = useState("binance");
  const [externalId, setExternalId] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [scope, setScope] = useState<"read" | "trade">("read");
  const [error, setError] = useState<string | null>(null);

  async function load() {
    try {
      const data = await api<LinkedAccount[]>("/v1/provider/accounts");
      setAccounts(data);
    } catch (e) {
      setError((e as Error).message);
    }
  }
  useEffect(() => {
    load();
  }, []);

  async function link() {
    setError(null);
    try {
      await api("/v1/provider/link-account", {
        method: "POST",
        body: {
          provider,
          external_account_id: externalId,
          scope,
          api_key: apiKey || undefined,
          api_secret: apiSecret || undefined,
        },
      });
      setExternalId("");
      setApiKey("");
      setApiSecret("");
      load();
    } catch (e) {
      setError((e as Error).message);
    }
  }

  async function unlink(id: string) {
    await api(`/v1/provider/accounts/${id}`, { method: "DELETE" });
    load();
  }

  return (
    <div className="page">
      <h1>Linked providers</h1>
      <p className="muted">
        Connect read-only or trade-scoped accounts. Credentials are encrypted at rest.
        Bitxian never executes against external venues without backend authorization.
      </p>
      {error && <div className="error">{error}</div>}
      <div className="list-card" style={{ marginBottom: 16 }}>
        <h3>Add account</h3>
        <div className="form-row">
          <select value={provider} onChange={(e) => setProvider(e.target.value)}>
            <option value="binance">Binance</option>
            <option value="kraken">Kraken</option>
            <option value="coinbase">Coinbase</option>
          </select>
          <input
            placeholder="External account id / label"
            value={externalId}
            onChange={(e) => setExternalId(e.target.value)}
          />
          <select value={scope} onChange={(e) => setScope(e.target.value as "read" | "trade")}>
            <option value="read">Read only</option>
            <option value="trade">Trade enabled</option>
          </select>
        </div>
        <div className="form-row">
          <input
            placeholder="API key (optional)"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
          <input
            type="password"
            placeholder="API secret (optional)"
            value={apiSecret}
            onChange={(e) => setApiSecret(e.target.value)}
          />
          <button type="button" className="btn btn-primary" onClick={link}>
            Link
          </button>
        </div>
      </div>
      <table className="markets-table">
        <thead>
          <tr>
            <th>Provider</th>
            <th>External id</th>
            <th>Scope</th>
            <th>Status</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {accounts.map((a) => (
            <tr key={a.id}>
              <td>{a.provider}</td>
              <td className="muted">{a.external_account_id}</td>
              <td>{a.scope}</td>
              <td>{a.status}</td>
              <td>
                <button
                  type="button"
                  className="btn btn-ghost btn-sm"
                  onClick={() => unlink(a.id)}
                  disabled={a.status === "revoked"}
                >
                  {a.status === "revoked" ? "Revoked" : "Unlink"}
                </button>
              </td>
            </tr>
          ))}
          {accounts.length === 0 && (
            <tr>
              <td colSpan={5} className="muted">
                No linked accounts.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
